// dashboard-agent-ia/src/components/LangSelector.js
import React from 'react'
import { useLang } from '../context/LangContext'

const langs = [
  { code: 'fr', flag: 'fr', label: 'FR' },
  { code: 'en', flag: 'gb', label: 'EN' },
  { code: 'wo', flag: 'sn', label: 'WO' },
]

const LangSelector = ({ center = false, dark = true }) => {
  const { lang, changeLang } = useLang()

  return (
    <div className={`flex gap-2 ${center ? 'justify-center' : ''}`}>
      {langs.map(l => (
        <button key={l.code} onClick={() => changeLang(l.code)}
          className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-all flex items-center gap-1.5
            ${lang === l.code
              ? 'bg-blue-500 text-white'
              : dark ? 'bg-white/10 text-white/70 hover:bg-white/20' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}>
          <img src={`https://flagcdn.com/${l.flag}.svg`} alt={l.label}
            style={{width:'18px',height:'12px',objectFit:'cover',borderRadius:'2px'}} />
          <span>{l.label}</span>
        </button>
      ))}
    </div>
  )
}

export default LangSelector
